import { createSelector } from 'reselect'

import { selectQbrState } from './selectQbrState'

export const selectQBRUserRole = createSelector([selectQbrState], (state) => state.userRole)
